import React, { useState, useCallback } from 'react';
import useArticleStore from './stores/useArticleStore';
import ImageUpload from '../shared/ImageUpload';
import ContentTabBar from './ContentTabBar';
import RichTextEditor from './RichTextEditor';
import { useTranslations } from './contexts/TranslationContext';

export default function FormBody({ scheduleAutosave, csrfToken }) {
  var t = useTranslations();
  const [activeTab, setActiveTab] = useState('id');
  const contentId = useArticleStore((s) => s.content_id);
  const contentEn = useArticleStore((s) => s.content_en);
  const image = useArticleStore((s) => s.image);
  const imageUrl = useArticleStore((s) => s.image_url);
  const publishErrors = useArticleStore((s) => s.publishErrors);
  const updateField = useArticleStore((s) => s.updateField);

  const handleIdChange = useCallback((html) => {
    updateField('content_id', html);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleEnChange = useCallback((html) => {
    updateField('content_en', html);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleFileSelect = useCallback((file) => {
    updateField('image', file);
    updateField('remove_image', false);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  const handleImageRemove = useCallback(() => {
    updateField('image', null);
    updateField('image_url', null);
    updateField('remove_image', true);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  return (
    <div className="form-body">
      <div data-tour="cover_image">
        <ImageUpload
          file={image}
          imageUrl={imageUrl}
          errors={publishErrors && publishErrors.image ? publishErrors.image : null}
          onFileSelect={handleFileSelect}
          onRemove={handleImageRemove}
          translations={t}
        />
      </div>
      <div data-tour="content_tabs">
        <ContentTabBar activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div data-tour="editor" className={activeTab === 'id' ? 'd-block' : 'd-none'}>
        <RichTextEditor
          content={contentId}
          onChange={handleIdChange}
          placeholder={t.content_id_placeholder}
          csrfToken={csrfToken}
        />
      </div>
      <div className={activeTab === 'en' ? 'd-block' : 'd-none'}>
        <RichTextEditor
          content={contentEn}
          onChange={handleEnChange}
          placeholder={t.content_en_placeholder}
          csrfToken={csrfToken}
        />
      </div>
    </div>
  );
}
